import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      {" "}
      <section className="bestsellers-section">
        <div className="section-header">
          <h2>Shop All</h2>
        </div>

        <div className="products-grid">
          {productData.map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              key={product.id}
              className="product-card"
              onClick={toTop}
            >
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <h3>{product.name}</h3>
              <div className="product-price">
                from <span className="price">€{product.price}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Shop;
